'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { ROUTES } from '../../../constants/routes';
import { AUTH_SESSION_QUERY_KEY } from '../constants';
import { clearStoredSession } from '../lib/authSessionStorage';

export function useSignOut() {
  const queryClient = useQueryClient();
  const router = useRouter();

  return () => {
    clearStoredSession();
    queryClient.setQueryData(AUTH_SESSION_QUERY_KEY, null);
    router.replace(ROUTES.home);
  };
}
